$(function () {
    function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return re.test(email);
    }

    if ($(".js-signup-form").length > 0) {
        const form = $(".js-signup-form");

        if ($(".js-input-phone-number").length > 0) {
            $(".js-input-phone-number").keyup(function () {
                var num = $(this).val().replace(/\D/g, "");
                $(this).val(num);
            });
        }

        $(".js-step-1").click(function () {
            let email = form.find("#email").val();
            let age = form.find("input[name=age]:checked").val();
            let job = form.find("input[name=job]:checked").val();
            let job_other = form.find("#job_other").val();

            if (!email || !validateEmail(email)) {
                $(".js-error-email").addClass("error");
            } else {
                $(".js-error-email").removeClass("error");
            }

            if (!age) {
                $(".js-error-age").addClass("error");
            } else {
                $(".js-error-age").removeClass("error");
            }

            if (!job) {
                $(".js-error-job").addClass("error");
            } else {
                $(".js-error-job").removeClass("error");
            }

            if (job == "อื่นๆ / Others" && !job_other) {
                $(".js-error-job_other").addClass("error");
                return;
            } else {
                $(".js-error-job_other").removeClass("error");
            }

            if (email && age && job && validateEmail(email)) {
                form.find(".-step").addClass("d-none");
                $("#step2").removeClass("d-none");
                $("html,body").scrollTop(0);
            }
        });

        $(".js-step-2").click(function () {
            let favorite = form.find("input[name=favorite]:checked").val();
            let satisfaction_level = form
                .find("input[name=satisfaction_level]:checked")
                .val();
            let accept = form.find('input[name="accept"]').is(":checked");

            if (!favorite) {
                $(".js-error-favorite").addClass("error");
            } else {
                $(".js-error-favorite").removeClass("error");
            }

            if (!satisfaction_level) {
                $(".js-error-satisfaction_level").addClass("error");
            } else {
                $(".js-error-satisfaction_level").removeClass("error");
            }

            if (!accept) {
                $(".js-error-accept").addClass("error");
            } else {
                $(".js-error-accept").removeClass("error");
            }

            if (favorite && satisfaction_level && accept) {
                signupStore();
            }
        });

        // $(".js-step-3").click(function () {
        //     let name = form.find("#name").val();
        //     let tel = form.find("#tel").val();
        //     let company = form.find("#company").val();

        //     if (name && tel && company) {
        //         signupStore();
        //     }
        // });
        $(".js-contact-input").click(function () {
            if ($(this).is(":checked")) {
                $(".js-step-thanks")
                    .removeClass("opacity-0")
                    .removeAttr("disabled");
            } else {
                $(".js-step-thanks")
                    .addClass("opacity-0")
                    .attr("disabled", "disabled");
            }
        });

        $(".js-step-thanks").click(function () {
            form.find(".-step-thanks").addClass("d-none");
            form.find(".-step-contact").removeClass("d-none");
        });

        $(".js-step-contact").click(function () {
            let name = form.find("#name").val();
            let tel = form.find("#tel").val();
            let company = form.find("#company").val();
            let interested_in = form
                .find("input[name=interested_in]:checked")
                .val();

            if (!name) {
                $(".js-error-name").addClass("error");
            } else {
                $(".js-error-name").removeClass("error");
            }

            if (!tel || tel.length != 10) {
                $(".js-error-tel").addClass("error");
            } else {
                $(".js-error-tel").removeClass("error");
            }

            if (!company) {
                $(".js-error-company").addClass("error");
            } else {
                $(".js-error-company").removeClass("error");
            }

            if (!interested_in) {
                $(".js-error-interested_in").addClass("error");
            } else {
                $(".js-error-interested_in").removeClass("error");
            }

            if (
                name &&
                tel &&
                interested_in &&
                interested_in &&
                tel.length == 10
            ) {
                signupContactStore();
            }
        });

        function signupContactStore() {
            const formUrl = form.attr("action");
            const formData = new FormData();
            formData.append("name", form.find("#name").val());
            formData.append("tel", form.find("#tel").val());
            formData.append("company", form.find("#company").val());
            formData.append(
                "interested_in",
                form.find("input[name=interested_in]:checked").val()
            );

            axios({
                method: "post",
                url: formUrl,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(function (response) {
                let data = response.data;

                if (data.status == "error") {
                    if (!data.messages) {
                        return;
                    }

                    let messages = data.messages;

                    for (const key in messages) {
                        console.log(messages);
                        form.find(`.js-error-${key}`).addClass("error");
                    }

                    return;
                }

                if (data.status != "success") {
                    return;
                }

                window.top.location.href = data.url;
            });
        }

        function signupStore() {
            const formUrl = form.attr("action");
            const formData = new FormData();
            formData.append("_token", form.find("input[name=_token]").val());
            formData.append("email", form.find("#email").val());
            formData.append("age", form.find("input[name=age]:checked").val());
            formData.append("job", form.find("input[name=job]:checked").val());
            formData.append("job_other", form.find("#job_other").val());
            formData.append(
                "favorite",
                form.find("input[name=favorite]:checked").val()
            );
            formData.append(
                "satisfaction_level",
                form.find("input[name=satisfaction_level]:checked").val()
            );

            // let contact = form.find("input[name=contact]:checked").val();

            // if (contact) {
            //     let interested = form
            //         .find("input[name=interested]:checked")
            //         .val();
            //     if (interested) {
            //         formData.append("interested", interested);
            //     }
            //     formData.append("contact", contact);
            //     formData.append("name", form.find("#name").val());
            //     formData.append("tel", form.find("#tel").val());
            //     formData.append("company", form.find("#company").val());
            //     formData.append(
            //         "interested_in",
            //         form.find("#interested_in").val()
            //     );
            //     formData.append(
            //         "contact_other",
            //         form.find("#contact_other").val()
            //     );
            // }

            form.find(".js-error").removeClass("error");

            axios({
                method: "post",
                url: formUrl,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(function (response) {
                let data = response.data;

                if (data.status == "error") {
                    if (!data.messages) {
                        return;
                    }

                    let messages = data.messages;

                    for (const key in messages) {
                        console.log(messages);
                        form.find(`.js-error-${key}`).addClass("error");
                    }

                    return;
                }

                if (data.status != "success") {
                    return;
                }

                window.top.location.href = data.url;
            });
        }
    }
});
